import React from 'react';
import moment from 'moment';
import { Box, Flex, Icon, icons, Stat, StatLabel, StatNumber, chakra as C } from '@tapresearch/ui/components';
import useAsset from '../hook/useAsset';
export function FieldingStats(param) {
    var firstResponse = param.firstResponse, lastResponse = param.lastResponse, completesCount = param.completesCount, originalTotal = param.originalTotal, campaignStatus = param.campaignStatus;
    var asset = useAsset();
    var firstResponseText = moment(firstResponse).format('MM/DD/YY h:mm A');
    var durationText = lastResponse && campaignStatus === asset.constants.STATUS_COMPLETE ? moment.duration(moment(lastResponse).diff(firstResponse)).humanize() : undefined;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, firstResponse && /*#__PURE__*/ React.createElement(Box, styles.metric, /*#__PURE__*/ React.createElement(Stat, {
        color: "gray.500"
    }, /*#__PURE__*/ React.createElement(StatLabel, {
        mb: 1,
        fontWeight: "medium"
    }, "Launched"), /*#__PURE__*/ React.createElement(StatNumber, styles.statValue, firstResponseText, durationText && /*#__PURE__*/ React.createElement(Flex, {
        position: 'relative',
        mt: 1,
        align: 'center',
        fontSize: 'xs'
    }, /*#__PURE__*/ React.createElement(Icon, {
        color: "green.600",
        icon: icons.fi.CheckCircle
    }), /*#__PURE__*/ React.createElement(C.span, {
        fontWeight: "medium",
        color: "gray.600",
        letterSpacing: 0,
        ml: 2
    }, "Completed in ", durationText))))), /*#__PURE__*/ React.createElement(Box, styles.metric, /*#__PURE__*/ React.createElement(Stat, {
        color: "gray.500"
    }, /*#__PURE__*/ React.createElement(StatLabel, {
        mb: 1,
        fontWeight: "medium"
    }, "Responses"), /*#__PURE__*/ React.createElement(StatNumber, styles.statValue, completesCount, " / ", originalTotal))));
}
var styles = {
    metric: {
        display: 'inline-block',
        margin: '0 1px',
        padding: '7px 20px 7px 0',
        fontWeight: 'bold',
        fontSize: 'sm',
        color: 'gray.500',
        marginRight: '25px',
        _last: {
            mr: '0'
        }
    },
    statValue: {
        fontSize: 'xl',
        fontWeight: 'normal',
        color: 'gray.700',
        letterSpacing: 'tight',
        m: 0
    }
};
